{
  "logoAlternateText": "Pekao Gwarancje",
  "navbar": {
    "links": {
      "guaranteeOrders": "Zlecenia",
      "styleGuide": "Style guide"
    }
  },
  "topbar": {
    "links": {
      "settings": {
        "notifications": "Ustawienia powiadomień"
      }
    }
  }
}
